import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';

const PhysicalDue = (record) =>{

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'physicaldue',
        payload: { id: (record && record.ssn) ? record.ssn: null}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //console.log(data)
    return (data)
}

export default PhysicalDue